import pl from '../JsonLang/pl.json'
export const lang = { ...pl }